module.exports = __webpack_public_path__ + "static/media/BD_website_02a_pb.52c1d461.jpg";